export default "__VITE_ASSET__2f0aa64b__"